<template>
    <input 
    @keydown="onKeyDown"
    @mousedown="onMouseDown"
    @focus="onFocus"
    @blur="onBlur"
    ref="inputRef"
    :value="value"
    @input="$emit('input', $event.target.value)"
    class="NumberController" :style="style">
</template>

<script>
    export default {
        name: 'NumberController',
        data: function () {
            return { currentValue: 0};
        },
        props: ["value", "width", "min", "max", "precision", "step"],
        mounted: function() {
            this.distance = 0;
            this.pointer = [0, 0];
            this.prevPointer = [0, 0];
            this.onMouseDownValue = 0;
            this.currentStep = 1;
            this.currentMin = -Infinity;
            this.currentMax = Infinity;
            this.currentPrecision = 2;

            if (this.value) {
                this.currentValue = this.value;
            }

            if (this.step) {
                this.currentStep = this.step;
            }

            if (this.min) {
                this.currentMin = this.min;
            }

            if (this.max) {
                this.currentMax = this.max;
            }

            if (this.precision) {
                this.currentPrecision = this.precision;
            }
        },
        methods: {
            onMouseDown(e) {
                //console.log("onMouseDown");
                e.preventDefault();
                this.distance = 0;
                this.prevPointer = [ e.clientX, e.clientY ];
                this.onMouseDownValue = parseFloat(this.currentValue);

                document.addEventListener("mousemove", this.onMouseMove, false);
                document.addEventListener("mouseup", this.onMouseUp, false);
            },
            onMouseUp() {
                //console.log("onMouseUp");
                document.removeEventListener("mousemove", this.onMouseMove, false);
                document.removeEventListener("mouseup", this.onMouseUp, false);

                if (Math.abs(this.distance) < 2) {
                    this.$refs["inputRef"].focus();
                    this.$refs["inputRef"].select();
                }
            },
            onMouseMove(e) {
                //console.log("onMouseMove");
                this.pointer = [e.clientX, e.clientY];
                this.distance += (this.pointer[0] - this.prevPointer[0]) - (this.pointer[1] - this.prevPointer[1]);
                var value = this.onMouseDownValue + (this.distance / (e.shiftKey ? 5 : 50)) * this.currentStep;
                value = Math.min(this.currentMax, Math.max(this.currentMin, value));

                //console.log(value);
                this.currentValue = value.toFixed(this.currentPrecision);
                if (!this.currentValue) {
                    this.currentValue = 0;
                }
                this.prevPointer = [e.clientX, e.clientY];
            },
            onKeyDown(e) {
                //console.log("onMouseDown");
                switch ( event.keyCode ) {
                    case 13: // enter
                        //console.log("ENTER");
                        this.onBlur()
                        this.$refs.inputRef.blur();
                        break;
                    case 38: // up
                        e.preventDefault();
                        //scope.setValue( scope.getValue() + scope.nudge );
                        //dom.dispatchEvent( changeEvent );
                        break;

                    case 40: // down
                        e.preventDefault();
                        //scope.setValue( scope.getValue() - scope.nudge );
                        //dom.dispatchEvent( changeEvent );
                        break;

                }
            },
            onFocus() {
                //console.log("onFocus");
                this.$refs.inputRef.style.backgroundColor = '';
                this.$refs.inputRef.style.cursor = '';
            },
            onBlur() {
                //console.log("onBlur");
                var value = parseFloat(this.$refs.inputRef.value);
                //this.currentValue = value.toFixed(this.currentPrecision);
                this.currentValue = value;
                if (!this.currentValue) {
                    this.currentValue = 0;
                }

                this.$refs.inputRef.style.backgroundColor = 'transparent';
                this.$refs.inputRef.style.cursor = 'col-resize';


            },
        },
        computed: {
            style: function() {
                if (this.width) {
                    return { width: this.width + "px" };
                }
                return {};
            },
        },
        watch: {
            currentValue: function() {
                this.$emit('input', this.currentValue);
            },
        },
    }
</script>

<style>
.NumberController {
    display: inline;
    background-color: transparent;
    cursor: col-resize;
    border: 0px;
    padding: 2px;
    font-size: 16px;
    color: #08f;
}
</style>
